import { DB_COLUMN_NAMES } from '@federa/const/column-names';

/**
 * The REDUCER dispatch vocabulary -- the `type` tag on every action the app-state reducers switch on.
 *
 * Named `REDUCER_ACTION_TYPES`, not `ACTION_TYPES`: that shorter name belongs to `const/action-types.ts`, the
 * `actions.action_type` DOMAIN vocabulary, and two leaves owning one name is what QUAL-CONST-DUPLICATE-EXPORT-NAME-001
 * reports -- both are reached as `@federa/const/<topic>`, so an author who greps the name and imports whichever hit came
 * first binds the wrong semantics and it still type-checks.
 */
export const REDUCER_ACTION_TYPES = {
	USER_UPDATE: 'user/update',
	AUTH_UPDATE: 'auth/update',
	APP_REHYDRATE: 'app/rehydrate',
	MESSAGING_UPDATE: 'messaging/update',
	MESSAGING_SET_MESSAGES: 'messaging/setMessages',
	MESSAGING_SET_ROOMS: 'messaging/setRooms',
	MESSAGING_ADD_ROOM: 'messaging/addRoom',
	MESSAGING_SET_AGENT_STATUS: 'messaging/setAgentStatus',
	EXPLORE_SET_PROPERTIES: 'explore/setProperties',
	EXPLORE_ADD_PROPERTIES: 'explore/addProperties',
	EXPLORE_UPDATE_OR_PREPEND_PROPERTIES: 'explore/updateOrPrependProperties',
	EXPLORE_EXTEND_AUCTION: 'explore/extendAuction',
	/** A whole feed-hub frame of auction deltas, committed in one reducer pass. */
	EXPLORE_EXTEND_AUCTIONS: 'explore/extendAuctions',
	EXPLORE_SET_WISHLISTS: 'explore/setWishlists',
	EXPLORE_SET_LOADING: 'explore/setLoading',
	EXPLORE_SET_USER_SEARCHING: 'explore/setUserSearching',
	EXPLORE_SET_HIDE_SUGGESTIONS: 'explore/setHideSuggestions',
	EXPLORE_SET_SEARCH_TERM: 'explore/setSearchTerm',
	EXPLORE_SET_USER_CREATING_PROPERTY: 'explore/setUserCreatingProperty',
	PROPERTY_DETAIL_SET_PROPERTY: 'propertyDetail/setProperty',
	PROPERTY_DETAIL_SET_AUCTION: 'propertyDetail/setAuction',
	PROPERTY_DETAIL_SET_PROPERTY_ID: 'propertyDetail/setPropertyId',
	PROPERTY_DETAIL_SET_FACTS: 'propertyDetail/setFacts',
	PROPERTY_DETAIL_PATCH_FACT: 'propertyDetail/patchFact',
} as const;

export const FORM_FIELDS = {
	// The two audit-stamp members are D1 column names first; DERIVED from the column SSOT so the form-side keys cannot drift from the migration chain.
	MODIFYING_FLOW: DB_COLUMN_NAMES.MODIFYING_FLOW,
	OFFER_STATUS: 'offer_status',
	ADDED_TIME: 'added_time',
	MODIFIED_TIME: DB_COLUMN_NAMES.MODIFIED_AT,
	FUNDING_SOURCE: 'funding_source',
	OFFER_AMOUNT: 'offer_amount',
	ACCOUNT_CREATED_DATE_TIME: 'account_created_date_time',
	STRIPE_ID: 'stripe_id',
	SECURITY_DEPOSIT: 'security_deposit',
	PROPERTY_ADDRESS: 'property_address',
	INDIVIDUAL_ACCOUNT_OWNER: 'individual_account_owner_id',
	PROPERTY_LINK: 'property',
	ADDRESS: 'address',
	ACTION_STATUS: 'action_status',
	AUCTION_STATUS: 'auction_status',
} as const;
